export default "__VITE_ASSET__CSEFlbcv__"